define.alias("shared/components/shared/ember-drop-multi-select", "preview-grid/components/shared/ember-drop-multi-select");